import React from 'react'
import {Link} from "react-router-dom"

import {Typography, Box} from "@material-ui/core"
import Grid from '@mui/material/Grid'
import useMediaQuery from '@mui/material/useMediaQuery'

import theme from '../../../themes/_main'
import {useStyles} from '../../../themes/styles'

import img_logo from '../../../images/oss2.webp'

function Steps() {
  const desktop = useMediaQuery(`(min-width:${theme.breakpoints.values.md}px)`)
  const classes = useStyles()

  return( <>
    <Box className={classes.spacing + " " + classes.blockFull}>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Typography variant="h4" align="center" className={desktop ? "" : classes.blockFull}>How It Works</Typography>
          <Box direction="row" alignItems="flexStart" spacing={1} className={classes.spacing + " " + classes.spacingLeft}>
            <Typography variant="h5" className={classes.fontScript}>
              Step 1: 
            </Typography>
            <Typography variant="h6">
              <b>Book Your Song</b> - Choose your package, pick a time for your lyricist session, and check out.
            </Typography>
          </Box>
          <Box direction="row" alignItems="flexStart" spacing={1} className={classes.spacing + " " + classes.spacingLeft}>
              <Typography variant="h5" className={classes.fontScript}>
              Step 2:
            </Typography>
            <Typography variant="h6">
              <b>Chat With a Lyricist</b> – On your scheduled call, we’ll learn all about your story and what you want in your song.
            </Typography>
          </Box>
          <Box direction="row" alignItems="flexStart" spacing={1} className={classes.spacing + " " + classes.spacingLeft}>
              <Typography variant="h5" className={classes.fontScript}>
              Step 3:
            </Typography>
            <Typography variant="h6">
              <b>Approve Your Lyrics</b> – Get the first draft within 48 hours, request tweaks (up to five rounds), and give the final thumbs-up.
            </Typography>
          </Box>
          <Box direction="row" alignItems="flexStart" spacing={1} className={classes.spacing + " " + classes.spacingLeft}>
              <Typography variant="h5" className={classes.fontScript}>
              Step 4:
            </Typography>
            <Typography variant="h6">
              <b>We Make the Magic Happen</b> – Our musicians turn your lyrics into a fully produced song in your chosen style.
            </Typography>
          </Box>
          <Box direction="row" alignItems="flexStart" spacing={1} className={classes.spacing + " " + classes.spacingLeft}>
              <Typography variant="h5" className={classes.fontScript}>
              Step 5:
            </Typography>
            <Typography variant="h6">
              <b>Get Your Song!</b> – Receive a download link within 7 days (or 48 hours with rush delivery). Add-ons like a custom lyric card or streaming upload are available at checkout!
            </Typography>
          </Box>
        </Grid>

        <Grid item md={6}>
          <img src={img_logo} alt="Our Story Song Logo" className={classes.image}/>
        </Grid>
      </Grid>
    </Box>
  </>)
}

export default Steps
